(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-arena/assets/javascripts/onboarding/onboarding.js') >= 0) return;  svs.modules.push('/modules/racing-arena/assets/javascripts/onboarding/onboarding.js');
"use strict";



const {
  useState
} = React;
const {
  Revealer
} = svs.components.racing;
const {
  ReactIcon
} = svs.ui;
const Onboarding = _ref => {
  let {
    isOnboard,
    setIsonBoard
  } = _ref;
  const widgetArea = document.querySelector('#racing-arena-widget-area');
  const racingThemeOnboard = document.querySelector('.racing-theme-onboard');
  const onboardWidgetArea = document.querySelector('#racing-onboarding');
  const [showRevealer, setShowRevealer] = useState(false);
  const [revealerExpand, setRevealerExpand] = useState(true);
  const [hasRevealed, setHaRevealed] = useState(false);
  const hideThemeTransitionEnd = () => {
    setTimeout(() => {
      racingThemeOnboard.style.display = 'none';
      onboardWidgetArea.classList.replace('racing-onboarding-hidden', 'racing-onboarding-not-hidden');
      setShowRevealer(false);
    }, 400);
  };
  const closeRevealer = () => {
    onboardWidgetArea.classList.replace('racing-onboarding-not-hidden', 'racing-onboarding-hidden');
    svs.components.Storage.browser.set('seenOnboard', 'Racing', true, svs.components.Storage.constants.EXPIRES_1YEAR);
    setRevealerExpand(false);
    racingThemeOnboard.style.display = null;
    widgetArea.style.maxHeight = '100%';
    empPlayer.getPlayer('vjs_video_3_empShaka_api').dispose();
    setTimeout(() => {
      setIsonBoard(false);
      widgetArea.style.display = null;
      racingThemeOnboard.style.maxHeight = null;
      setShowRevealer(false);
    }, 200);
  };
  if (isOnboard) {
    if (racingThemeOnboard) {
      if (!hasRevealed) {
        setHaRevealed(true);
        racingThemeOnboard.style.maxHeight = '0%';
        widgetArea.style.maxHeight = '0%';
        widgetArea.style.display = 'none';
        setIsonBoard(true);
        setTimeout(() => {
          setShowRevealer(true);
          hideThemeTransitionEnd();
        }, 200);
      }
    }
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "racing-revealer-close"
  }, React.createElement("button", {
    className: "qa-back-button icon-button",
    onClick: closeRevealer,
    type: "button"
  }, React.createElement(ReactIcon, {
    color: "white",
    icon: "close",
    size: "300"
  }))), React.createElement(Revealer, {
    isExpandMode: revealerExpand,
    isVisible: showRevealer
  }, React.createElement("div", {
    className: "margin-3"
  })));
};
svs.racing_arena.Onboarding = Onboarding;

 })(window);